// extracted by mini-css-extract-plugin
export default {"spinner":"ButtonSpinner_spinner__oNyJi","spin":"ButtonSpinner_spin__gIGGm"};